export const getDeepObjectValuesByKey = (
  obj: any,
  keyToFind: string,
): never[] =>
  Object.entries(obj).reduce(
    (acc, [key, value]) =>
      key === keyToFind
        ? acc.concat(value as any)
        : typeof value === 'object'
        ? acc.concat(getDeepObjectValuesByKey(value, keyToFind))
        : acc,
    [],
  );
